import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { AuthProvider } from '@/contexts/AuthContext';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    {/*
      WR-01: sonner.tsx consumes useTheme() from next-themes; without a
      ThemeProvider, that hook returns undefined and the dark token block
      in index.css plus every dark: Tailwind variant are dead code.

      Brand spec is light-first (stone/sage/cream); system-respect for
      dark mode is a Phase 10+ decision. Lock attribute="class" so the
      class consumed by Tailwind's dark variant matches the convention.
    */}
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
